import React, { useState, useEffect, useRef } from 'react';
import { useLocation,Link } from 'react-router-dom';
import axios from 'axios';
import { Button, Modal, Form } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import ContactModal from './ContactModal';
import withPermission from '../../utils/withPermission';
import Swal from 'sweetalert2';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const API_URL = `${backendUrl}/api/contact`;

function ContactsDetails({ }) {
    const location = useLocation();
    const [contacts, setContacts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [errors, setErrors] = useState({});
    const WithEditPermission = withPermission(({ children }) => children, ['contact-edit']);
    const WithDeletePermission = withPermission(({ children }) => children, ['contact-delete']);
    const WithCreatePermission = withPermission(({ children }) => children, ['contact-create']);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        contact_id: '',
        type: null,
        position: '',
    });
    const [isEdit, setIsEdit] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);

    // Ref to track whether the API call has been made
    const didFetchRef = useRef(false);



    // useEffect(() => {
    //     if (!didFetchRef.current) {
    //         // setFormData((prev) => ({ ...prev }));
    //         fetchContacts();
    //         didFetchRef.current = true;  // Mark the fetch as done
    //     }
    // }, []); // Dependencies are instanceId and pathname

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }

        debounceTimeoutRef.current = setTimeout(() => {
            fetchContacts(1, searchQuery);
        }, searchQuery ? 1500 : 0); 

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [searchQuery]);
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);

    };   
    const fetchContacts = async ( page = 1) => {
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            const response = await axios.get(`${API_URL}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    page,
                    search: searchQuery,
                },
            });
            setContacts(response.data.Data);
            // const filteredContacts = response.data.Data.filter(
            //     contact => contact.type !== "instance" && contact.type !== "tenant"
            // );
    
            // setContacts(filteredContacts);
            setPageCount(response.data.last_page);

        } catch (error) {
            console.error('Error fetching contacts:', error);
        }
    };

    const handleAddContact = () => {
        setFormData({ name: '', email: '', phone: '', position: '' });
        setIsEdit(false);
        setSelectedContact(null);
        setShowModal(true);
        setErrors({});

    };

    const handleEditContact = (contact) => {
        setFormData(contact);
        setIsEdit(true);
        setSelectedContact(contact);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setErrors({}); // Clear any residual error
    };
    const handleDelete = async (id) => {
        Swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Yes, delete it!"
                }).then(async (result) => {
                    if (result.isConfirmed) {
            try {
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;
                await axios.delete(`${API_URL}/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setContacts(contacts.filter(contact => contact.id !== id));
             Swal.fire(
                            "Deleted!",
                            "The contact has been deleted.",
                            "success"
                        );
                    } catch (error) {
                        console.error('Error deleting contact:', error);
                        Swal.fire(
                            "Error!",
                            "Failed to delete contact. Please try again.",
                            "error"
                        );
                    }
                }
                });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        setErrors((prevErrors) => {
            const { [name]: removed, ...rest } = prevErrors; // Remove the key
            return rest;
        });
    };

    const handlePageChange = ({ selected }) => {
        const newPage = selected + 1;  // Adjusted because ReactPaginate uses 0-based indexing
        setCurrentPage(newPage); // Update the current page state
        fetchContacts(newPage); // Fetch new contacts based on the selected page
    };
    
    useEffect(() => {
        if (!showModal) {
            setErrors({});
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.phone) newErrors.phone = 'Phone is required';

        
        return newErrors;
      };
    const [loading, setLoading] = useState(false);
      
    const handleSubmit = async () => {
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return; 
        }
        try {
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            if (isEdit) {
                const response = await axios.put(`${API_URL}/${selectedContact.id}`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
                setContacts(contacts.map(contact => (contact.id === selectedContact.id ? response.data.contact : contact)));
            } else {
                const response = await axios.post(API_URL, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setContacts([...contacts, response.data.contact]);
            }
            setErrors({});

            setShowModal(false);
        } catch (error) {
           
                console.error("Unexpected error: ", error);
            
        }
    };
          const handleImport = async (event) => {
            const file = event.target.files[0];
            if (!file) return;
    
            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;
    
                const formData = new FormData();
                formData.append('file', file);
    
                const response = await axios.post(
                    `${backendUrl}/api/contact/import`,
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                            'Tenant-Origin': origin,
                        },
                    }
                );
    
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: response.data.message || ` Imported successfully!`,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
    
                // Refresh the list after import
                setTimeout(() => window.location.reload(), 1000);
    
                // Clear the file input
                event.target.value = '';
    
            } catch (error) {
                console.error('Import error:', error);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: error.response?.data?.errors || error.response?.errors || `Failed to import instance information`,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
                event.target.value = "";
    
            } finally {
            }
        };
    
        // Export Functions
        const handleExport = async () => {
            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;
    
                const response = await axios.get(
                    `${backendUrl}/api/contact/export`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                        responseType: 'blob', // Important for file download
                    }
                );
    
                // Create blob link and download
                const blob = new Blob([response.data]);
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
    
                // Get filename from response headers or use default
                const contentDisposition = response.headers['content-disposition'];
                let filename = `Contacts_${new Date().toISOString().split('T')[0]}.xlsx`;
    
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                    if (filenameMatch.length === 2) {
                        filename = filenameMatch[1];
                    }
                }
    
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
    
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: `Exported successfully!`,
                    timer: 2000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
    
            } catch (error) {
                console.error('Export error:', error);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: `Failed to export`,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } finally {
            }
        };

    return (
        <>
        <div className="main-content">
        <div className="page-content">
            <div className="container-fluid ">
                <div className="row w-100">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0 font-size-18">Contact</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    {/* <li className="breadcrumb-item"><a href="javascript:void(0);">Category</a></li> */}
                                    {/* <li className="breadcrumb-item active">Category List</li> */}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between mb-3">
                                        <div className="d-flex">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search..."
                                                        value={searchQuery}
                                                        onChange={handleSearchChange}
                                                    />
                                                    <i className="bx bx-search-alt search-icon" />
                                                </div>
                                            </div>



                                        </div>
                                               <div className="d-flex align-items-center gap-2">
                                            {/* Export Button */}
                                            <button
                                                type="button"
                                                className="btn btn-light border"
                                                onClick={handleExport}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Export"
                                            >
                                                <i className="mdi mdi-file-excel text-success"></i>
                                            </button>

                                            {/* Import Button */}
                                            <input
                                                type="file"
                                                accept=".xlsx, .xls"
                                                id="importLeadsFile"
                                                onChange={handleImport}
                                                style={{ display: "none" }}
                                            />
                                            <label
                                                htmlFor="importLeadsFile"
                                                className="btn btn-light border mb-0"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                title="Import"
                                            >
                                                <i className="mdi mdi-upload text-primary"></i>
                                            </label>
                                       <WithCreatePermission>
                                       <button
                                                    type="button"
                                                    className="btn rounded-circle border d-flex align-items-center justify-content-center round-create-button"
                                                  
                                                    onClick={handleAddContact}                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Add Contact"
                                                >
                                                    <i className="mdi mdi-plus" ></i>
                                                </button>
                                        </WithCreatePermission>
                                        </div>
                                    </div>
                                        <table className="table align-middle table-nowrap table-check table-list">

                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{ width: '20px' }} className="align-middle">
                                                        <div className="form-check font-size-16">
                                                            <input className="form-check-input" type="checkbox" id="checkAll" />
                                                            <label className="form-check-label" htmlFor="checkAll"></label>
                                                        </div>
                                                    </th>
                                                    <th className="align-middle">#</th>
                                                    <th className="align-middle"> Name</th>
                                                    <th className="align-middle">Email</th>
                                                    <th className="align-middle">Phone</th>
                                                    <th className="align-middle">Position</th>
                                                    <th className="align-middle">Contact Type</th>

                                                    <th className="align-middle">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {contacts.map((contact,index) => (
                                                    <tr key={contact.id}>
                                                        <td>
                                                            <div className="form-check font-size-16">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id={`instanceCheck${index}`}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor={`instanceCheck${index}`}
                                                                ></label>
                                                            </div>
                                                        </td>
                                                        <td>{index + 1}</td>

                                                        <td><Link to={`/contact/details/${contact.id}`} className="dropdown-item">
                                                        {contact.name}</Link></td>
                                                        <td>{contact.email}</td>
                                                        <td>{contact.phone}</td>
                                                        <td>{contact.position}</td>
                                                        <td>{contact.contact_type}</td>

                                                        <td>
                                                            <div className="dropdown">
                                                                <i
                                                                    className="mdi mdi-dots-horizontal font-size-18"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                    style={{ cursor: 'pointer' }}
                                                                ></i>
                                                                <ul className="dropdown-menu dropdown-menu-end font-size-14">
                                                                    <li><WithEditPermission>
                                                                        <button className="dropdown-item" onClick={() => handleEditContact(contact)}>
                                                                            Edit
                                                                        </button></WithEditPermission>
                                                                    </li>
                                                                    <li><WithDeletePermission>
                                                                        <button className="dropdown-item" onClick={() => handleDelete(contact.id)}>
                                                                            Delete
                                                                        </button></WithDeletePermission>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-end pagination-sm">
                                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={handlePageChange}
                            containerClassName={'pagination pagination-rounded justify-content-end mb-2'}
                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item previous'}
                            previousLinkClassName={'page-link'}
                            nextClassName={'page-item next'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                            activeClassName={'active'}
                        />
                                        </div>
                                       
                                        </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          
        </div>
          <ContactModal
         showModal={showModal}
         handleClose={handleCloseModal}
         handleSubmit={handleSubmit}
         formData={formData}
         handleInputChange={handleInputChange}
         errors={errors}
         isEdit={isEdit}
     />
     </>
      
                                    );
}
export default ContactsDetails;


